module.exports = __webpack_public_path__ + "static/media/qa.b1303a15.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/qa.svg
// module id = 1144
// module chunks = 0